import { useRegion } from './regionUtils'
import { parseGraphQLHeadings } from './tocUtils'

export type Chapter = {
  path: string
  heading: string
  children: Chapter[]
}

export function buildBookChapters(gqlChapters: {
  edges: {
    node: {
      slug: string
      headings: { value: string; depth: number }[]
    }
  }[]
}) {
  return (
    gqlChapters.edges
      .map(({ node }) => {
        const path = getBookPath(node.slug)
        return {
          path,
          heading: node.headings[0]?.value,
          children: parseGraphQLHeadings(
            node.headings
              .filter(h => h.depth === 2)
              .map(h => ({ ...h, depth: 0 })),
          ).map(heading => ({
            path: path + '#' + heading.id,
            heading: heading.text,
            children: [],
          })),
        }
      })
      // This would not necessary, but there is some Gatsby bug that causes the
      // sorting to not work in `buildBookTemplate`
      .sort((a, b) => a.path.localeCompare(b.path))
  )
}

export function getBookPath(slug: string) {
  return '/build/' + slug.split('/')[0] + '/'
}

export function useBuyUrl() {
  const region = useRegion() ?? 'US'

  let tld = 'com'
  switch (region) {
    case 'GB':
    case 'JE':
    case 'GG':
    case 'IM':
    case 'IE':
      tld = 'co.uk'
      break
    case 'AD':
    case 'AL':
    case 'AT':
    case 'BE':
    case 'BA':
    case 'BG':
    case 'BY':
    case 'HR':
    case 'CY':
    case 'CH':
    case 'CZ':
    case 'DK':
    case 'EE':
    case 'FI':
    case 'DE':
    case 'GR':
    case 'HU':
    case 'LV':
    case 'LT':
    case 'LU':
    case 'MC':
    case 'MD':
    case 'ME':
    case 'MK':
    case 'RS':
    case 'TR':
    case 'MT':
    case 'NO':
    case 'PL':
    case 'RO':
    case 'SM':
    case 'SK':
    case 'SI':
    case 'UA':
    case 'VA':
      tld = 'de'
      break
    case 'ES':
    case 'PT':
      tld = 'es'
      break
    case 'FR':
      tld = 'fr'
      break
    case 'IT':
      tld = 'it'
      break
    case 'NL':
      tld = 'nl'
      break
    /*
    Uncomment if stores start selling Kindle books

    case 'PL':
      tld = 'pl'
      break
    case 'SE':
      tld = 'se'
      break

    */
    case 'NZ':
    case 'AU':
      tld = 'com.au'
      break
    case 'CA':
      tld = 'ca'
      break
    case 'JP':
      tld = 'co.jp'
      break
    default:
      tld = 'com'
      break
  }

  return `https://www.amazon.${tld}/dp/B0CNGYYVF7/`
}
